
import { v4 as uuidv4 } from "uuid";
import { UpgradableNumber } from "@dndModels/misc/UpgradableNumber";

export class HitDice {
  true_id: string;
  size: number;
  used: number;
  count: number;

  constructor(obj?: any) {
    this.true_id = uuidv4().toString();
    this.size = obj ? +obj.size : 8;
    this.used = obj && obj.used ? +obj.used : 0;
    this.count = obj ? +obj.count : 0;
  }

  toDBObj(): any {
    return {
      size: this.size,
      used: this.used,
      count: this.count
    };
  }

  copy(copyMe: HitDice, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.size = copyMe.size;
    this.used = copyMe.used;
    this.count = copyMe.count;
  }

  clone(drop_ids = false): HitDice {
    const new_obj = new HitDice();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class HitDiceUpgradable {
  true_id: string;
  size = 8;
  count: UpgradableNumber = new UpgradableNumber();

  constructor(obj?: any) {
    this.true_id = uuidv4().toString();
    if (obj) {
      this.size = obj.size ? obj.size : 8;
      this.count = obj ? new UpgradableNumber(obj.count) : new UpgradableNumber();
    }
  }

  toDBObj(): any {
    return {
      size: this.size,
      count: this.count.toDBObj()
    };
  }

  copy(copyMe: HitDiceUpgradable, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.size = copyMe.size;
    this.count = copyMe.count.clone();
  }

  clone(drop_ids = false): HitDiceUpgradable {
    const new_obj = new HitDiceUpgradable();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}